import { render, staticRenderFns } from "./RegionsMap.vue?vue&type=template&id=9c758e1a&scoped=true"
import script from "./RegionsMap.vue?vue&type=script&lang=js"
export * from "./RegionsMap.vue?vue&type=script&lang=js"
import style0 from "./RegionsMap.vue?vue&type=style&index=0&id=9c758e1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c758e1a",
  null
  
)

export default component.exports